import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useCreateSubModule } from '../../../hooks/useCreateSubModule';
import { useUpdateSubModule } from '../../../hooks/useUpdateSubModule';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';

export default function SubModuleForm({ successCallback = null, module = null, subModule = null, mode = "create", open, onClose }) {

    const { t } = useTranslation('common'); 

    const [name, setName] = React.useState(subModule ? subModule.name : "");
    const [sequence, setSequence] = React.useState(subModule ? subModule.sequence : "");

    const { create } = useCreateSubModule(successCallback);
    const { update } = useUpdateSubModule(successCallback);

    const { showSnackbar } = useSnackbar();

    React.useEffect(() => {
        // reset field when company changes (e.g. when opening edit)
        setName(subModule ? subModule.name : "");
        setSequence(subModule ? subModule.sequence : "");
    }, [subModule, open]);

    const handleSave = async () => {
        if (!name.trim()) {
            showSnackbar(t('app_sub_modules.messages.name_required'), "warning");
            return;
        }
        if (!sequence) {
            showSnackbar(t('app_sub_modules.messages.sequence_required'), "warning");
            return;
        }

        try 
        {
            if (mode === "create") {
                await create({ app_module_id: module.id , name, sequence });
                showSnackbar(t('app_sub_modules.messages.create_success'), "success");
            } else if (mode === "edit" && module) {
                await update(subModule.id, { name, sequence });
                showSnackbar(t('app_sub_modules.messages.update_success'), "success");
            }
            setName("");
            setSequence("");
            onClose();     // close dialog
        } catch (err) {
            showSnackbar(t('app_sub_modules.messages.save_fail'), "error");
        }

    };

    const handleCancel = () => {
        setName("");
        setSequence("");
        onClose();
    };

    return (
        <Dialog onClose={handleCancel} open={open} disableRestoreFocus>
        <DialogTitle>{mode === "create" ? "Add SubModule" : "Edit SubModule"}</DialogTitle>

        <DialogContent dividers>
            <Stack spacing={1}>
              <Typography variant='h6'>
                {module?.name}
              </Typography>
              <TextField
                  label="Module Name"
                  variant="outlined"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  fullWidth
              />
              <TextField
                  label="Sequence Number"
                  variant="outlined"
                  value={sequence}
                  onChange={(e) => setSequence(e.target.value)}
                  fullWidth
                  type='number'
              />
            </Stack>
        </DialogContent>

        <DialogActions>
            <Button onClick={handleSave}>Save</Button>
            <Button onClick={handleCancel}>Cancel</Button>
        </DialogActions>
        </Dialog>
    );
}